'use strict'

_ = require 'underscore'
CardUI = require 'grpn-card-ui/frontend/init'
plannerPresenter = require '../presenters/planner'
plannerTemplate = require '../../planner.html.mustache'
ErrorHtml = require './error_html'
isTTDLandingPage = require '../../../page/frontend/helpers/is_ttd_landing_page'
plannerRetriever = require '../model/planner'

module.exports = class PlannerView
  constructor: (options) ->
    @options = options
    @el = options.el
    @hash = plannerPresenter.toHash()
    @plannerModel = plannerRetriever
    @hash.dates = @_filterDates @options.availabilityData
    @load()

  load: ->
    @_hidePlanner() unless isTTDLandingPage()
    @hash.loading = true
    @hash.error = false
    @hash.widgetEnabled = true
    @render()
    @_fetchResults @hash.dates[0].rapiId if @hash?.dates?.length

  render: ->
    if @_shouldRender()
      @_showPlanner()
      this
    else
      @_hidePlanner()
      return

  _shouldRender: ->
    @hash.dates and
    @hash.dates.length >= 2 and
    isTTDLandingPage()

  _showPlanner: ->
    @hash.widgetEnabled = true
    $(@el).html plannerTemplate.render @hash
    @_setupClickListeners()

  _hidePlanner: ->
    return unless @hash
    @hash.widgetEnabled = false
    @hash.resultsHtml = null
    $(@el).html plannerTemplate.render @hash

  _onPlannerError: ->
    @hash.loading = false
    @hash.error = true
    @hash.resultsHtml = null
    @hash.errorHtml = ErrorHtml.render()
    @render()

  _fetchResults: (dateRange) ->
    return unless dateRange?
    return unless isTTDLandingPage()

    datetime = "#{dateRange}:"

    filter =
      category2: 'tickets-and-events'
      datetime: datetime
      isTTDLandingPage: isTTDLandingPage()
    data = _.extend {}, filter,
      limit: 16
      csrf: @options._csrf

    @plannerModel.getPlanAheadCarousel(data)
      .then (response) =>
        @hash.widgetEnabled = false unless response.plannerWidgetHtml
        @hash.resultsHtml = response.plannerWidgetHtml
        @hash.loading = false
        CardUI.init()
        @render()
      .catch (response) =>
        @_onPlannerError()

  _filterDates: (dates) ->
    dates = _.filter dates, (child) ->
      child.count >= 4
    dates[0].selected = true if dates?.length
    dates

  _setupClickListeners: ->
    buttons = $(@el).find('.date-group')
    buttons.on('click', (e) => @_handleDateClick(e))

  _handleDateClick: (e) ->
    newlySelected = $(e.target).attr('id')

    _.each @hash.dates, (date) ->
      date.selected = date.id == newlySelected

    @hash.loading = true
    @render()
    @_fetchResults $(e.target).attr('data-id')